import { render, staticRenderFns } from "./nav2.vue?vue&type=template&id=4c7e73ff&scoped=true"
import script from "./nav2.vue?vue&type=script&lang=js"
export * from "./nav2.vue?vue&type=script&lang=js"
import style0 from "./nav2.vue?vue&type=style&index=0&id=4c7e73ff&lang=scss"
import style1 from "./nav2.vue?vue&type=style&index=1&id=4c7e73ff&lang=scss&scoped=true"
import style2 from "./nav2.vue?vue&type=style&index=2&id=4c7e73ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e73ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7e73ff')) {
      api.createRecord('4c7e73ff', component.options)
    } else {
      api.reload('4c7e73ff', component.options)
    }
    module.hot.accept("./nav2.vue?vue&type=template&id=4c7e73ff&scoped=true", function () {
      api.rerender('4c7e73ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/nav2.vue"
export default component.exports